import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { LastEditedBanner, messageToString, MessagePropType } from '@ratehub/base-ui';


function AdditionalInformationBanner({
    message,
    lastEditDate,
    ...otherProps
}) {
    const intl = useIntl();

    return (
        <LastEditedBanner
            lastEditDate={lastEditDate}
            {...otherProps}
        >
            <p className="rh-text-s rh-m-0">
                {messageToString(message, intl)}
            </p>
        </LastEditedBanner>
    );
}

AdditionalInformationBanner.propTypes = {
    message: MessagePropType.isRequired,
    lastEditDate: PropTypes.string,
};

export default AdditionalInformationBanner;
